import { takeLatest } from "redux-saga/effects";
import actions from "../constants/rtoRequestApprovalsActions";
import {
  getRtoRequestListWorker,
  updateRtoRequestStatusWorker,
} from "../workers/rtoRequestApprovalsWorker";

export function* getRtoRequestListWatcher() {
  yield takeLatest(actions.GET_RTO_REQUEST_LIST, getRtoRequestListWorker);
}

export function* updateRtoRequestStatusWatcher() {
  yield takeLatest(actions.UPDATE_RTO_REQUEST_STATUS, updateRtoRequestStatusWorker);
}
